import type { ItemDef } from './types'

/** Boost Jet: `speedPct` extra speed for `durationTicks`, mud does not slow it. */
export const boostJet: ItemDef = {
  id: 'boost_jet',
  use(world, i) {
    const p = world.players[i]!
    const { speedPct, durationTicks } = world.cfg.items.boostJet
    p.boostUntil = world.tick + durationTicks
    p.boostPct = speedPct
    p.boostIgnoresMud = true
  },
}
